import React from 'react';
import { TEditUserSelectedItem } from '../../../../../editUserState/editUserContext';
import { IItemForGetShortInfo, UserRoles } from 'types';
import CustomerSelect from './CustomerSelect';
import { CustomersMultipleSelect } from './CustomersMultipleSelect';
import RestaurantsMultipleSelect from './RestaurantsMultipleSelect/RestaurantsMultipleSelect';

interface IAdditionalFields {
	roleName: string;
	selectedCustomer: TEditUserSelectedItem;
	selectedCustomers: string[];
	selectedRestaurants: string[];
	initialIDsSelectedRestaurant: string[];
	setCustomer: (value: TEditUserSelectedItem) => void;
	setCustomers: (value: string[]) => void;
	setFetchedCustomers: (value: IItemForGetShortInfo[]) => void;
	setRestaurants: (value: string[]) => void;
	setFetchedRestaurants: (value: IItemForGetShortInfo[]) => void;
}

const AdditionalFields: React.FC<IAdditionalFields> = ({
	roleName,
	selectedCustomer,
	selectedCustomers,
	selectedRestaurants,
	initialIDsSelectedRestaurant,
	setCustomer,
	setCustomers,
	setFetchedCustomers,
	setRestaurants,
	setFetchedRestaurants,
}) => {
	switch (roleName) {
		case UserRoles.CLIENT_MANAGER:
			return (
				<CustomerSelect
					setCustomer={setCustomer}
					setFetchedCustomers={setFetchedCustomers}
					selectedCustomer={selectedCustomer}
				/>
			);
		case UserRoles.GROUP_MANAGER:
			return (
				<CustomersMultipleSelect
					setIDsCustomer={setCustomers}
					setFetchedCustomers={setFetchedCustomers}
					IDsSelectedCustomer={selectedCustomers}
				/>
			);
		case UserRoles.RESTAURANT_MANAGER:
			return (
				<>
					<CustomerSelect
						setCustomer={setCustomer}
						setFetchedCustomers={setFetchedCustomers}
						selectedCustomer={selectedCustomer}
					/>
					<RestaurantsMultipleSelect
						setRestaurants={setRestaurants}
						setFetchedRestaurants={setFetchedRestaurants}
						selectedCustomer={selectedCustomer}
						selectedRestaurants={selectedRestaurants}
						initialIDsSelectedRestaurant={initialIDsSelectedRestaurant}
					/>
				</>
			);
		default:
			return null;
	}
};

export default React.memo(AdditionalFields);
